import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";
import { Dimmer } from "../spinner";

const headCells = [
  {
    id: "1",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> N° Factura</p>,
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Fecha/Emisión</p>,
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Descripción</p>,
    textAlign: "center",
  },
  {
    id: "4",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Estatus</p>,
    textAlign: "center",
  },
  {
    id: "5",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Total</p>,
    textAlign: "center",
  },
];

const TablaRelacionFacturasproc = (props) => {
  const [activate, setActivate] = useState(false);

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 280);

  const [url, setUrl] = useState("");

  useEffect(() => {
    if (props.factura) {
      setRecords(props.factura);
    }
  }, [props.factura]);

  return (
    <div className="card">
      <Dimmer active={activate} />
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={item.anio + item.mes}
                          style={{ padding: "0" }}
                        >
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.numfactura}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechaemision).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.descripcion}
                          </TableCell>
                          <TableCell
                            className="fw-bold"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              color:
                                item.status === "COBRADA"
                                  ? "#008f39"
                                  : item.status === "VERIFICANDO PAGO"
                                  ? "#ffae00"
                                  : "#F93154",
                            }}
                          >
                            {item.status}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.totalfactura.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaRelacionFacturasproc;



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/tablaRelacionFacturas.js